export default __webpack_public_path__ + "static/media/OmaduroTorpedo.7c63f9eb.png";